import React from "react";
import U2000Calendar from "../../../formControls/calendar/U2000Calendar";

type U2000SearchCriteriaDateFieldProps = React.ComponentProps<typeof U2000Calendar>;

/**
 * Date simple dans les critères de recherche : même comportement que `U2000Calendar`
 * avec saisie manuelle dans le pied du popup (Aujourd'hui | input | Effacer).
 * N'affecte pas les formulaires qui utilisent `U2000Calendar` sans ce wrapper.
 */
const U2000SearchCriteriaDateField: React.FC<U2000SearchCriteriaDateFieldProps> = (props) => (
  <U2000Calendar {...props} showPopupFooterDateInput />
);

export default U2000SearchCriteriaDateField;
